import { memo } from 'react';

interface SectionConfigProps {
    title: string;
    titleColor: string;
    subtitle: string;
    subtitleColor: string;
    onTitleChange: (value: string) => void;
    onTitleColorChange: (value: string) => void;
    onSubtitleChange: (value: string) => void;
    onSubtitleColorChange: (value: string) => void;
    disabled: boolean;
}

const highlightInput = (inputId: string) => {
    document.getElementById(inputId)?.classList.add('input-highlight-border');
};

const unhighlightInput = (inputId: string) => {
    document.getElementById(inputId)?.classList.remove('input-highlight-border');
};

export const SectionConfig = memo(({
    title,
    titleColor,
    subtitle,
    subtitleColor,
    onTitleChange,
    onTitleColorChange,
    onSubtitleChange,
    onSubtitleColorChange,
    disabled,
}: SectionConfigProps) => {

    const renderSectionInput = (
        label: string,
        inputId: string,
        value: string,
        onValueChange: (val: string) => void,
        placeholder: string,
        colorValue: string,
        onColorChange: (val: string) => void,
        colorLabel: string
    ) => (
        <div className="input-with-color-row">
            <h5>{label}</h5>
            <div className="input-wrapper">
                <input
                    id={inputId}
                    type="text"
                    value={value}
                    onChange={(e) => onValueChange(e.target.value)}
                    placeholder={placeholder}
                    disabled={disabled}
                />
                <label
                    className="color-picker-pill"
                    onMouseEnter={() => highlightInput(inputId)}
                    onMouseLeave={() => unhighlightInput(inputId)}
                >
                    <p>{colorLabel}</p>
                    <input
                        type="color"
                        value={colorValue}
                        onChange={(e) => onColorChange(e.target.value)}
                        disabled={disabled}
                    />
                </label>
            </div>
        </div>
    );

    return (
        <div className="edit-section">
            <h3 className="section-title">Edit Side by Side Cards</h3>

            {renderSectionInput(
                "Section Title (Optional)",
                "section-title-input",
                title,
                onTitleChange,
                "Enter the section title here.",
                titleColor,
                onTitleColorChange,
                "Title Color"
            )}

            {renderSectionInput(
                "Section Subtitle (Optional)",
                "section-subtitle-input",
                subtitle,
                onSubtitleChange,
                "Enter the section subtitle here.",
                subtitleColor,
                onSubtitleColorChange,
                "Subtitle Color"
            )}
        </div>
    );
});
